import { theme } from '@Guidelines/Theme/theme';
import type { DeclarationFieldSource } from '@UI/Pages/DocumentTemplates/Shared/Declaration/DeclarationGroupView';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Tag } from '@verclam/ui-kit';

/** One variable per row: its label, then its type. Rows are told apart by a hairline, not by a box. */
const rowStyle = css`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 0.75rem;
	flex-wrap: wrap;
	padding: 0.4375rem 0;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	color: ${theme.colors.ink};
`;

const labelStyle = css`
	display: flex;
	align-items: center;
	gap: 0.5rem;
	flex-wrap: wrap;
`;

type Props = {
	readonly field: DeclarationFieldSource;
};

const DeclarationFieldRow: React.FC<Props> = ({ field }) => {
	return (
		<div css={rowStyle}>
			<span css={labelStyle}>
				<span>{field.label}</span>
				{field.isRequired ? <Tag value="requise" severity="info" /> : null}
			</span>
			<Tag value={field.type.label} severity="secondary" />
		</div>
	);
};

export default DeclarationFieldRow;
